import client from './client'

export default {
  get () {
    return client.get('/raccolte?include=sequences,sequences.reel')
  }
}
